import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Arayüz hatası", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center p-6" data-testid="error-boundary">
        <div className="panel p-8 max-w-md space-y-4 text-center">
          <h1 className="font-display text-3xl font-black">Bir şeyler ters gitti</h1>
          <p className="text-slate-300">Ekran beklenmedik bir hatayla karşılaştı. Oyun sunucuda devam ediyor; sayfayı yenileyince kaldığın yerden dönersin.</p>
          <button onClick={() => window.location.reload()} className="h-12 px-6 rounded-xl bg-[#FACC15] text-[#05070D] font-bold" data-testid="error-reload-button">
            Sayfayı yenile
          </button>
        </div>
      </div>
    );
  }
}
